import ApiEndpoint, { ApiResponse } from '../../network/ApiEndpoint'

export interface ConnectTeamRequest {
  teamId: string
  competitionId: string
  channelSlug: string
}
interface Response {
  hasError: boolean
  errors?: any
}
export const putConnectGamesToTeam = async (
  request: ConnectTeamRequest
): Promise<Response> => {
  try {
    const response: ApiResponse = await ApiEndpoint.call({
      path: `companies/${request.channelSlug}/competitions/${request.competitionId}/teams/${request.teamId}/connect_channel`,
      method: ApiEndpoint.METHODS.PUT,
      authenticatable: true
    })
    await response
    return { hasError: false }
  } catch (error: any) {
    console.error('error!', error)
    return {
      hasError: true,
      errors: [error]
    }
  }
}
